class LandingPageOrderButton extends HTMLElement {
  constructor() {
    super();

    // data-url="/cart/{{ page.metafields.custom.product.value.selected_or_first_available_variant.id }}:1?discount={{ block.settings.discount_code }}"
    const orderButtonElement = this.querySelector('.landing-page-order-button__button');
    const discountCode = this.dataset.discountCode;

    if(orderButtonElement) {
      this.setOrderButtonEvent(orderButtonElement, this, discountCode);
    }
  }

  setOrderButtonEvent(orderButtonElement, parentElement, discountCode) {
    orderButtonElement.addEventListener('click', (e) => {
      e.preventDefault();

      // Get the value from the active variant
      const selectedVariant = parentElement.querySelector('.product-variant-id').value;
      console.log(selectedVariant);
      console.log(discountCode);

      location.href = '/cart/' + selectedVariant + ':1?discount=' + discountCode;
    });
  }
}

customElements.define('landing-page-order-button', LandingPageOrderButton);